import React, { useState, useEffect } from 'react'
import Loader from '../../component/loader/Loader'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { IoRefreshOutline } from 'react-icons/io5'
import Flatpickr from 'react-flatpickr'
import "flatpickr/dist/themes/light.css"
import { LuFileEdit, LuTrash2 } from 'react-icons/lu';
import { LuChevronLeft, LuChevronRight } from 'react-icons/lu'
import DataTablePagination from '../../component/data_table/DataTablePagination';
import { useFormik } from 'formik';
import SaveButton from '../../component/buttons/SaveButton';
import { ChallanListRes, ChallanListTodo } from '../../redux/Slices/Challan/ChallanList';
import DataTable from '../../component/data_table/DataTable';
import { InvoicePDFRes, InvoicePDFTodo } from '../../redux/Slices/Challan/InvoicePdf';
import { toast, ToastContainer } from 'react-toastify';
// import DeleteInvoice from './DeleteInvoice';


export default function InvoiceList() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [bool, setBool] = useState(false)
    const [loading, setLoading] = useState(false)
    const [pageLimit, setPageLimit] = useState(10)
    const [pageSize, setPageSize] = useState(0)
    const [deleteModal, setDeleteModal] = useState(false)
    const [invoiceData, setInvoiceData] = useState(false)
    const [filterLoad, setFilterLoad] = useState(false)

    const invoice_list = useSelector(state => state?.ChallanList?.data?.list)
    // const TotalCount = useSelector(state => state?.ChallanList?.data?.list_size)
    // console.log(invoice_list, 'invoice')

    const initialValues = {
        search: '',
        fromDate: '',
        toDate: ''
    }
    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,

        onSubmit: (values, action) => {
            setFilterLoad(true)
            dispatch(ChallanListTodo({ "search": values.search, "fromDate": values.fromDate, "toDate": values.toDate })).then(() => filter_res())
        }
    })
    // console.log(values, 'vb')

    const handleSearch = (data) => {
        dispatch(ChallanListTodo({ "search": data, "fromDate": values.fromDate, "toDate": values.toDate }))
    }

    const handleReset = () => {
        values.search = ''
        setFieldValue('fromDate', ""); // Reset fromDate
        setFieldValue('search', "");   // Reset search
        setBool(!bool);                // Toggle bool state if necessary
    };

    const filter_res = () => {
        if (ChallanListRes && ChallanListRes.success) {
            setFilterLoad(false)
        } else {
            setFilterLoad(false)
        }
    }

    const pdfGenrate = (data) => {
        setFilterLoad(true)
        dispatch(InvoicePDFTodo(data.vcom_invoice_code)).then(() => pdf_res())
    }

    const pdf_res = () => {
        if (InvoicePDFRes && InvoicePDFRes.status) {
            setFilterLoad(false)
            toast.success(InvoicePDFRes?.message, { position: "bottom-right" });
            setTimeout(() => {
                window.open(InvoicePDFRes?.return_file, '_blank');
            }, 1500);


        } else {
            setFilterLoad(false)
            toast.error(InvoicePDFRes?.message, { position: "bottom-right" });
        }
    }



    useEffect(() => {
        setLoading(true)
        dispatch(ChallanListTodo({ "search": values.search, "fromDate": values.fromDate, "toDate": values.toDate, })).then(() => invoiceListFun())
    }, [bool])

    const invoiceListFun = () => {
        if (ChallanListRes && ChallanListRes.success) {

            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const columnDefs = [
        {
            headerName: 'S.NO',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 70
        },
        {
            headerName: 'INVOICE CODE',
            field: 'vcom_invoice_code',
            cellRenderer: params =>
                <span
                    onClick={() => pdfGenrate(params?.data)}
                    style={{
                        fontSize: '16px',
                        fontWeight: "600",
                        color: 'red',
                        cursor: 'pointer'
                    }}>
                    {params?.data?.vcom_invoice_code}
                </span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'INVOICE DATE',
            field: 'dcom_invoice_date',
            cellRenderer: params => <span>{new Date(params?.data?.dcom_invoice_date).toLocaleDateString('en-GB')}</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
        },

        // {
        //     headerName: 'STATUS',
        //     field: 'status',
        //     filter: 'agTextColumnFilter',
        //     cellRenderer: params => params.data.status === 'active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
        //     suppressMenu: true,
        //     filter: true,
        //     sortable: true,
        //     floatingFilter: false,
        //     // wrapText: true,
        //     // autoHeight: true,
        // },
        // {
        //     field: 'ACTIONS',
        //     // cellRenderer: BranchAction,
        //     // cellRendererParams: {
        //     //     bool: bool,
        //     //     setBool: setBool,
        //     //     setLoading: setLoading,
        //     // },
        //     // wrapText: true,
        //     autoHeight: true,
        //     pinned: 'right',
        // }
    ]

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">

                        <div className='layout_head'>
                            <h5>Invoice List</h5>
                        </div>
                        {loading ?
                            <div className='mt-5 pt-5'>
                                <Loader />
                            </div>
                            :
                            <div>
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <label htmlFor="" className='form_label'>Invoice Code </label>
                                            <input
                                                type="text"
                                                id="challan_code"
                                                name='search'
                                                // onChange={(e) => handleSearch(e.target.value)}
                                                value={values.search}
                                                onChange={(e) => {
                                                    setFieldValue('search', e.target.value);
                                                    handleSearch(e.target.value)
                                                }}
                                                className="form-control form_input"
                                                onBlur={handleBlur}
                                            />
                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="" className='form_label'>From Date</label>

                                            <Flatpickr
                                                className='form_input form-control'
                                                name='fromDate'
                                                // value={values?.fromDate || new Date().toISOString()}
                                                options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: 'm-d-Y', // Customize date format as needed
                                                    minDate: '', // Before dates disabled
                                                    maxDate: '', // After dates disabled
                                                    disable: [], // Disable particular date ranges
                                                    mode: "single", //multiple-single-range
                                                    defaultDate: [], // Use today's date as default if none selected
                                                    conjunction: "", // Multiple dates separation
                                                }}
                                                onChange={(e) => {
                                                    setFieldValue('fromDate', moment(e[0]).format("DD/MM/YYYY"))
                                                }}
                                                onBlur={handleBlur}
                                            />

                                        </div>
                                        <div className="col-md-3">
                                            <label htmlFor="" className='form_label'>To Date</label>

                                            <Flatpickr
                                                className='form_input form-control'
                                                name='toDate'
                                                // value={values?.toDate || new Date().toISOString()}
                                                options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: 'm-d-Y', // Customize date format as needed
                                                    minDate: '', // Before dates disabled
                                                    maxDate: '', // After dates disabled
                                                    disable: [], // Disable particular date ranges
                                                    mode: "single", //multiple-single-range
                                                    defaultDate: [], // Use today's date as default if none selected
                                                    conjunction: "", // Multiple dates separation
                                                }}
                                                onChange={(e) => {
                                                    setFieldValue('toDate', moment(e[0]).format("DD/MM/YYYY"))
                                                }}
                                                onBlur={handleBlur}
                                            />

                                        </div>
                                        <div className="col-md-3">
                                            <div className='d-flex align-items-center mt-4 mb-1'>
                                                <SaveButton name={'FILTER'} />
                                                <button className='ms-1 refresh_btn' onClick={handleReset} ><IoRefreshOutline style={{ color: 'white' }} size={25} /></button>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                                {filterLoad ?
                                    <div className='d-flex juistify-content-center mt-5 '>
                                        <Loader />
                                    </div> :
                                    invoice_list?.length ?
                                        <>

                                            <div className="col-md-12 mt-1">
                                                <DataTable
                                                    rowData={invoice_list}
                                                    columnDefs={columnDefs}
                                                    height={'70vh'}
                                                />
                                            </div>
                                        </> :
                                        <div className='empty_section text-center'>
                                            <span>DATA NOT FOUND</span>
                                        </div>}
                            </div>

                        }
                    </div>
                </div>
            </div>
            <ToastContainer />
            {/* <DeleteInvoice deleteModal={deleteModal} setDeleteModal={setDeleteModal} invoiceData={invoiceData} bool={bool} setBool={setBool} /> */}
        </>
    )
}
